import { z } from "zod";

export const serverResponse = z.object({
  access_token: z.string(),
});

export type IRegisterResponse = z.infer<typeof serverResponse>;
